import { render } from "./FormAlert.vue?vue&type=template&id=64e7ca56&scoped=true"
import script from "./FormAlert.vue?vue&type=script&lang=js"
export * from "./FormAlert.vue?vue&type=script&lang=js"

import "./FormAlert.vue?vue&type=style&index=0&id=64e7ca56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e7ca56"]])

export default __exports__